// SiteUP CRM (2026-09-18): estado da seleção de cartões do Kanban.
// Singleton de módulo de propósito: o cartão marca, a coluna marca a etapa
// inteira e a barra de seleção lê, sem atravessar prop por três níveis de
// componente. A regra está em helper/kanbanSelection.js.
import { computed, ref } from 'vue';
import {
  addItems,
  clearSelection,
  isSelected,
  pruneSelection,
  removeItems,
  selectedIds,
  selectedItems,
  selectedItemsWithConversation,
  stageSelectionState,
  toggleItem,
  toggleStage,
} from 'dashboard/helper/kanbanSelection';

const selection = ref(new Map());

export const useKanbanSelection = () => {
  const count = computed(() => selection.value.size);
  const hasSelection = computed(() => selection.value.size > 0);
  const items = computed(() => selectedItems(selection.value));
  const ids = computed(() => selectedIds(selection.value));
  const itemsWithConversation = computed(() =>
    selectedItemsWithConversation(selection.value)
  );

  const isItemSelected = item => isSelected(selection.value, item);

  const toggle = item => {
    selection.value = toggleItem(selection.value, item);
  };

  const select = list => {
    selection.value = addItems(selection.value, list);
  };

  const deselect = list => {
    selection.value = removeItems(selection.value, list);
  };

  const toggleStageItems = stageItems => {
    selection.value = toggleStage(selection.value, stageItems);
  };

  const stageState = stageItems =>
    stageSelectionState(selection.value, stageItems);

  const clear = () => {
    selection.value = clearSelection();
  };

  const prune = knownIds => {
    selection.value = pruneSelection(selection.value, knownIds);
  };

  return {
    selection,
    count,
    hasSelection,
    items,
    ids,
    itemsWithConversation,
    isItemSelected,
    toggle,
    select,
    deselect,
    toggleStageItems,
    stageState,
    clear,
    prune,
  };
};

export default useKanbanSelection;
